
import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import PaginatedTable from './PaginatedTable';

class TestimonialTable4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 15,
      totalRows: 20,
      data: [
        { name: 'Emmanuel', jobTitle: 'Site Reliability Engineer', salary: '140k/year' },
        { name: 'Mouyo', jobTitle: 'Site Reliability Engineer', salary: '110k/year' },
        { name: 'Jimi', jobTitle: 'Sr Software Engineer', salary: '147k/year' },
        { name: 'Randy', jobTitle: 'Site Reliability Engineer', salary: '120k/year' },
        { name: 'Justice', jobTitle: 'Site Reliability Engineer', salary: '110k/year' },
        { name: 'Adesoji', jobTitle: 'Site Reliability Engineer', salary: '125k/year' },
        { name: 'De Bonheur', jobTitle: 'Software Engineer', salary: '90k/year' },
        { name: 'Paula', jobTitle: 'Software Engineer', salary: '110k/year' },
        { name: 'Viviane', jobTitle: 'CI Build Engineer', salary: '110k/year' },
        { name: 'Lungowe', jobTitle: 'Cloud DevOps Developer', salary: '110k/year' },
        { name: 'Adesoji', jobTitle: 'Cloud DevOps Developer', salary: '134k/year' },
        { name: 'Jeraldine', jobTitle: 'Soft OP Engineer', salary: '113k/year' },
        { name: 'Lionel', jobTitle: 'Site Reliability Engineer', salary: '131k/year' },
        { name: 'Maris', jobTitle: 'Site Reliability Engineer', salary: '166k/year' },
        { name: 'Djock', jobTitle: 'Softw and application Eng', salary: '85k/year' },
        { name: 'Armel', jobTitle: 'Software Engineer', salary: '115k/year' },
        { name: 'Miranda', jobTitle: 'Software Engineer', salary: '115k/year' },
      ],
    };
  }

  nextPage = () => {
    const { currentPage, pageSize, totalRows } = this.state;
    const maxPage = Math.ceil(totalRows / pageSize);
    if (currentPage < maxPage) {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage + 1,
      }));
    }
  };

  previousPage = () => {
    const { currentPage } = this.state;
    if (currentPage > 1) {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage - 1,
      }));
    }
  };

  // render() {
  //   const { currentPage, pageSize, totalRows, data } = this.state;
  //   const startIndex = (currentPage - 1) * pageSize;
  //   const endIndex = startIndex + pageSize;
  //   const visibleData = data.slice(startIndex, endIndex);
  //   const showPreviousLink = currentPage > 1;
  //   const showNextLink = endIndex < totalRows;

  //   return (
  //     <div>
  //       <table id="customers">
  //         <thead>
  //           <tr>
  //             <th>Names</th>
  //             <th>Job title</th>
  //             <th>Salary per year</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {visibleData.map((row, index) => (
  //             <tr key={index}>
  //               <td>{row.name}</td>
  //               <td>{row.jobTitle}</td>
  //               <td>{row.salary}</td>
  //             </tr>
  //           ))}
  //         </tbody>
  //       </table>
  //       <ul className="edu-pagination">
  //         {showPreviousLink && (
  //           <li>
  //             <Link to="#" onClick={this.previousPage} aria-label="Previous">
  //               <i className="icon-west"></i>
  //             </Link >
  //           </li>
  //         )}
  //         <li className="active">
  //           <Link to="#">{currentPage}</Link>
  //         </li>
  //         {showNextLink && (
  //           <li>
  //             <Link to="#" onClick={this.nextPage}>{currentPage + 1}</Link>
  //           </li>
  //         )}
  //         <li className="more-next">
  //           <Link to="#"></Link >
  //         </li>
  //         <li>
  //           <Link to="#">{Math.ceil(totalRows / pageSize)}</Link >
  //         </li>
  //         <li>
  //           <Link to="#" onClick={this.nextPage} aria-label="Next">
  //             <i className="icon-east"></i>
  //           </Link>
  //         </li>
  //       </ul>
  //     </div>
  //   );
  // }
  render() {
    const { currentPage, pageSize, totalRows, data } = this.state;
    const showPreviousLink = currentPage > 1;
    const showNextLink = (currentPage - 1) * pageSize + 15 < totalRows;
  
    return (
      <PaginatedTable
        currentPage={currentPage}
        pageSize={pageSize}
        totalRows={totalRows}
        data={data}
        showPreviousLink={showPreviousLink}
        showNextLink={showNextLink}
        previousPage={this.previousPage}
        nextPage={this.nextPage}
      />
    );
  }
}

export default TestimonialTable4;

